import request from "./request";

const QuizMCQService = {
    GetAll: async (id, context, signal) => {
        return await request.sendRequest(`/quizmcq/all/${id}`, context.token, signal);
    },
    BulkSave: async (payload, context, signal) => {
        return await request.sendPostRequest(`/quizmcq/bulk`, payload, context, signal);
    },
    ImportMCQ: async (id, payload, context, signal) => {
        return await request.sendFormDataRequest(`/quizmcq/import/${id}`, payload, context, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/quizmcq`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/quizmcq/${id}`, context.token);
    },
};

export default QuizMCQService;
